export default {
      id: "oc-res-access-group-usage",
      viewBox: "0 0 1194 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-access-group",
      toString: function () {
        return this.url;
      }
    }